    import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
//import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Modal from "react-modal";


// Import Global Styles 
import './App.css';

// Import Layout Components
import Header from './components/Header';
import Footer from './components/Footer';

// Import Page Components
// Core Pages
import Index from './pages/Index';
import ContactUs from './pages/ContactUs';
import Dashboard from './pages/Dashboard';
import NotFound from './pages/NotFound';

// Table Management
import ViewTables from './pages/ViewTables';
import TableEditor from './pages/TableEditor';
import TableViewer from './pages/TableViewer';
import ResponsePathEditor from './components/ResponsePathEditor';
//import RecordEditor from './components/RecordEditor'; // Handles add/edit/view modes
//import RowHistoryWrapper from './wrappers/RowHistoryWrapper'; // Wraps RowHistory with routing

// Forms
//import FormList from './pages/FormList';
//import FormDesigner from './pages/FormDesigner';

// Reports
import ReportViewer from './pages/ReportViewer';
import ReportEditor from './pages/ReportEditor';
import ReportsPage from './pages/ReportsPage';
//import ReportDesigner from './pages/ReportDesigner';
//import ReportRunner from './pages/ReportRunner';

// Automations
//import AutomationPanel from './components/AutomationPanel';
import ScheduledAutomationList from './pages/ScheduledAutomationList';
//import ScheduledAutomationEditorWrapper from './wrappers/ScheduledAutomationEditorWrapper';
import AutomationLogList from './components/AutomationLogList';
import AutomationMonitoring from './pages/AutomationMonitoring';
//import ExecutionDetailsWrapper from './wrappers/ExecutionDetailsWrapper';
import TenantJobMonitoring from './pages/TenantJobMonitoring';


// Security
import SecurityAdmin from './pages/SecurityAdmin';
import UsersPanel from './components/UsersPanel';
import TeamsPanel from './components/TeamsPanel';
import GroupsPanel from './components/GroupsPanel';
import AuditingPanel from './components/AuditLogPanel';

// Auth
import Login from './pages/Login';
import Signup from './pages/Signup';
import ChangePassword from './pages/auth/ChangePassword';
import RequestPasswordReset from './pages/auth/RequestPasswordReset';
import ResetPassword from './pages/auth/ResetPassword';

// System Admin
//import TenantManagement from './pages/admin/TenantManagement';
//import TenantCategories from './pages/admin/TenantCategories';
//import PartitionManagement from './pages/admin/PartitionManagement';

// Misc / Utilities
import DataSets from './pages/DataSetsPage';
import PageDesigner from './pages/PageDesigner';
import MyApprovals from './pages/MyApprovals';
import ApprovalAdmin from './pages/ApprovalAdmin';
import BlobViewer from './components/BlobViewer';



// Set the App Element for React Modal
Modal.setAppElement("#root"); // Ensure this matches the root <div> in index.html

const App: React.FC = () => {
    //const location = useLocation();

    return (
        //<TransitionGroup>
        //    <CSSTransition key={location.key} classNames="fade" timeout={300}>
                <Routes>
                {/* Authentication Routes (No Header/Footer) */}
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />

                {/* Main App Routes (With Header & Footer) */}
                <Route
                    path="*"
                    element={
                        <>
                            <Header />
                            <div className="main-content">
                                <Routes>
                                    {/* Home & General */}
                                    <Route path="/" element={<Index />} />
                                    <Route path="/index" element={<Index />} />
                                    <Route path="/contactus" element={<ContactUs />} />
                                    <Route path="/dashboard" element={<Dashboard />} />

                                    {/* Tables */}
                                    <Route path="/tables" element={<ViewTables />} />
                                    <Route path="/tableeditor" element={<TableEditor />} />
                                    <Route path="/table/:tableId/view" element={<TableViewer />} />
                                    {/*<Route path="/table/:tableId/add" element={<RecordEditor mode="add" />} />*/}
                                    {/*<Route path="/table/:tableId/edit/:rowId" element={<RecordEditor mode="edit" />} />*/}
                                    {/*<Route path="/table/:tableId/view/:rowId" element={<RecordEditor mode="view" />} />*/}
                                    {/*<Route path="/table/:tableId/history/:rowId" element={<RowHistoryWrapper />} />*/}

                                    {/* Forms */}
                                    {/*<Route path="/forms" element={<FormList />} />*/}
                                    {/*<Route path="/forms/manage" element={<FormDesigner />} />*/}

                                    {/* Reports */}
                                    <Route path="/reports" element={<ReportViewer />} />
                                    <Route path="/reports/manage" element={<ReportEditor />} />
                                    <Route path="/reports/page" element={<ReportsPage />} />
                                    {/*<Route path="/reports/run/:reportId" element={<ReportRunner />} />*/}

                                    {/* Automations */}
                                    {/*<Route path="/automations" element={<AutomationPanel />} />*/}

                                    {/*<Route path="/automations/scheduled" element={<ScheduledAutomationList />} />*/}

                                    {/*<Route path="/automations/scheduled/edit" element={<ScheduledAutomationEditorWrapper />} />*/}
                                    <Route path="/automations/logs" element={<AutomationLogList />} />
                                    <Route path="/automations/monitoring" element={<AutomationMonitoring />} />
                                    {/*<Route path="/automations/execution/:logId" element={<ExecutionDetailsWrapper />} />*/}

                                    <Route path="/jobs/logs" element={<TenantJobMonitoring />} />
                                    
                                    {/* Security */}
                                    <Route path="/security" element={<SecurityAdmin />} />
                                    <Route path="/security/users" element={<UsersPanel />} />
                                    <Route path="/security/groups" element={<GroupsPanel />} />
                                    <Route path="/security/teams" element={<TeamsPanel />} />
                                    <Route path="/security/auditing" element={<AuditingPanel />} />

                                    {/* Auth */}
                                    <Route path="/auth/login" element={<Login />} />
                                    <Route path="/auth/change-password" element={<ChangePassword />} />
                                    <Route path="/auth/request-password-reset" element={<RequestPasswordReset />} />
                                    <Route path="/auth/reset-password/:token" element={<ResetPassword />} />

                                    {/* Admin / System */}
                                    {/*<Route path="/tenants" element={<TenantManagement />} />*/}
                                    {/*<Route path="/tenant-categories" element={<TenantCategories />} />*/}
                                    {/*<Route path="/partition-management" element={<PartitionManagement />} />*/}

                                    {/* Other Pages */}
                                    <Route path="/datasets" element={<DataSets />} />
                                    <Route path="/response-path-editor" element={<ResponsePathEditor />} />

                                    <Route path="/pages/designer" element={<PageDesigner />} />
                                    <Route path="/blobViewer" element={<BlobViewer />} />
                                    <Route path="/myapprovals" element={<MyApprovals />} />
                                    <Route path="/approvals/config" element={<ApprovalAdmin />} />


                                    {/* Catch-all */}
                                    <Route path="*" element={<NotFound />} />
                                </Routes>

                            </div>
                            <Footer />
                        </>
                    }
                />
            </Routes>
        
            //</CSSTransition>
            //</TransitionGroup>


    );
};

export default App;
